import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSearchParams } from 'react-router-dom'

import { getConfiguration } from 'services/config'
import { useTranslation } from 'services/i18n'

import { cn } from 'utils/cn'

import type { FC } from 'react'

export const ErrorAuthFailed: FC = () => {
  const [searchParams] = useSearchParams()
  const { authErrorLinks } = getConfiguration()
  const { t } = useTranslation('translation', {
    keyPrefix: 'errors',
  })

  const messageKey = searchParams.get('message') || 'default'
  const title = t(`auth.${messageKey}.title`, { defaultValue: t('auth.default.title') }) || t('auth.default.title')
  const subTitle = t(`auth.${messageKey}.subtitle`, { defaultValue: t('auth.default.subtitle') }) || t('auth.default.subtitle')
  const message = t(`auth.${messageKey}.description`, { defaultValue: t('auth.default.description') }) || t('auth.default.description')
  const telephone = t('footer.telephone')
  const email = t('footer.email')

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="kui-error-prompt">
        <div className="kui-error-prompt-container">
          <div className="flex justify-center">
            <div className={cn('kui-error-prompt-icon', { '!bg-critical !text-critical': messageKey === 'no_session' })}>
              <FontAwesomeIcon icon={faExclamationCircle} />
            </div>
          </div>

          <h1 className={cn('kui-error-prompt-title', { '!text-critical': messageKey === 'no_session' })}>{title}</h1>
          {subTitle && <p className="kui-error-prompt-subtitle">{subTitle}</p>}
          <p className="kui-error-prompt-message">{message}</p>

          {authErrorLinks && (
            <ul className="ml-4 list-disc">
              {authErrorLinks?.map(link => (
                <li key={link?.title}>
                  <a rel="noopener noreferrer" href={link?.href} className="kui-link">{link?.title}</a>
                </li>
              ))}
            </ul>
          )}

          <div className="kui-error-prompt-footer">
            <h2>{t('footer.title')}</h2>
            <p dangerouslySetInnerHTML={{
              __html: t('footer.description', {
                ...(telephone && { telephone: `<a href="tel:${telephone}" class="kui-link">${telephone}</a>` }),
                ...(email && { email: `<a href="mailto:${email}" class="kui-link">${email}</a>` }),
              }),
            }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
